<template>
  <div class="gj-tooltip">
    <template v-if="isMeaningful(content) || isMeaningful($slots['content'])">
      <el-tooltip
          v-bind="$attrs"
          v-on="$listeners"
          :content="content"
          :popper-class="mapPopperClass"
          :placement="placement"
          :effect="effect"
          :open-delay="openDelay">
        <div :class="[textEllipsis]" :style="{display: block ? '-webkit-box' : '-webkit-inline-box'}"><slot></slot></div>
        <template #content>
          <slot name="content"></slot>
        </template>
      </el-tooltip>
    </template>
    <template v-else>
      <div :class="[textEllipsis]" :style="{display: block ? '-webkit-box' : '-webkit-inline-box'}"><slot></slot></div>
    </template>
  </div>
</template>

<script>
  import {isMeaningful, isMeaningless} from "../../utils/common";
  import {isMeaningfulMixin} from "../../minxins";

  export default {
    name: "gj-tooltip",
    mixins: [isMeaningfulMixin],
    props: {
      effect: {
        type: String,
        default: 'dark'
      },
      content: {
        default: null
      },
      placement: {
        type: String,
        default: 'top'
      },
      widthAuto: {
        type: Boolean,
        default: false,
      },
      popperClass: {
        type: String,
        default: null,
      },
      openDelay: {
        type: Number,
        default: 400
      },
      textLine: {
        type: Number,
        default: null
      },
      block: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      mapPopperClass() {
        if (isMeaningful(this.popperClass)) {
          return this.popperClass;
        }
        return this.widthAuto ? '' : 'gj-tooltip--default';
      },
      textEllipsis() {
        if (isMeaningless(this.textLine)) {
          return '';
        }
        return  `text-ellipsis-${this.textLine}`;

      }
    }
  }
</script>

<style scoped>
  .gj-tooltip {
    display: inline-flex;
  }
</style>
